interface EnvironmentConfig {
  API_BASE_URL: string;
  WEB_BASE_URL: string;
  IS_PRODUCTION: boolean;
}

const getEnvironmentConfig = (): EnvironmentConfig => {
  // Production: frontend and backend on same origin → use relative URLs
  if (process.env.NODE_ENV === 'production') {
    return {
      API_BASE_URL: '/api',
      WEB_BASE_URL: '',
      IS_PRODUCTION: true,
    };
  }

  // Development: explicit env var or fallback to localhost
  const backendUrl = process.env.REACT_APP_API_URL || 'http://localhost:3001';
  return {
    API_BASE_URL: `${backendUrl}/api`,
    WEB_BASE_URL: backendUrl,
    IS_PRODUCTION: false,
  };
};

export const ENV_CONFIG = getEnvironmentConfig();

export const getApiUrl = (endpoint: string = ''): string =>
  `${ENV_CONFIG.API_BASE_URL}${endpoint}`;

export const getWebUrl = (path: string = ''): string =>
  `${ENV_CONFIG.WEB_BASE_URL}${path}`;

export const { API_BASE_URL, WEB_BASE_URL, IS_PRODUCTION } = ENV_CONFIG;
